import { Component, OnInit } from "@angular/core";
import { UtilsService } from "../../../../auth/service/utils.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthenticationService } from "../../../../auth/service";
import { RoleService } from "../../../../auth/service/role.service";
import { Router } from "@angular/router";
import { TicketService } from "../../ticket.service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { ICategoryTicket, ICategoryTicketForm } from "../../models/tickets";

@Component({
  selector: "app-categories-ticket-list",
  templateUrl: "./categories-ticket-list.component.html",
  styleUrls: ["./categories-ticket-list.component.scss"],
})
export class CategoriesTicketListComponent implements OnInit {
  public contentHeader: IContentHeader;
  public categories: ICategoryTicket[];
  public tableLimit: number = 10;
  public searchKeyword: string = "";
  public currentCategory: ICategoryTicket;
  public new_category: string = "";
  public new_description: string = "";
  public addRoles: number[] = [];
  public showModalErrors: boolean = false;

  constructor(
    public _ticketService: TicketService,
    public _utilService: UtilsService,
    public _modalService: NgbModal,
    public _authenticationService: AuthenticationService,
    public _roleService: RoleService,
    public _router: Router,
  ) {
    this._utilService.disableAutoHideLoading();
    this.contentHeader = {
      headerTitle: "MENU.CATEGORIES_SUPPORT_REQUEST",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.MANAGE",
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: "MENU.CATEGORIES_SUPPORT_REQUEST",
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("show_menu_categories_ticket")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    await this.loadCategories();
    this._utilService.hideLoading();
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }

  async loadCategories() {
    this.categories = await this._ticketService.getCategoriesList();
  }

  categoryList() {
    let items: ICategoryTicket[] = this.categories || [];

    const keywords: string = this.searchKeyword.trim().toLowerCase();
    if (keywords.length > 0) {
      items = items.filter((item: ICategoryTicket) => item.name.toLowerCase().includes(keywords));
    }

    return items;
  }

  async addCategory() {
    if (!this._authenticationService.hasCapability("ticket_category_create")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }

    if (!!this.new_category) {
      this.new_category = this.new_category.trim();
    }

    if (!this.new_category || this.new_category.length < 1 || !this.addRoles || this.addRoles.length < 1) {
      this.showModalErrors = true;
      return false;
    }

    const data: ICategoryTicketForm = {
      name: this.new_category,
      description: this.new_description,
      roles: this.addRoles,
    };

    this._utilService.showLoading();
    await this._ticketService
      .createCategory(data)
      .then(async () => {
        this._utilService.hideLoading();
        this._modalService.dismissAll();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_CREATE_CATEGORY" });
        await this.loadCategories();
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_CREATE_CATEGORY" });
      });
    this.new_category = "";
  }

  async editCategory() {
    if (!this._authenticationService.hasCapability("ticket_category_edit")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    if (!!this.currentCategory.name) {
      this.currentCategory.name = this.currentCategory.name.trim();
    }

    if (!this.currentCategory.name || this.currentCategory.name.length < 1 || !this.addRoles || this.addRoles.length < 1) {
      this.showModalErrors = true;
      return false;
    }

    const data: ICategoryTicketForm = {
      name: this.currentCategory.name,
      description: this.currentCategory.description,
      roles: this.addRoles,
    };
    this._utilService.showLoading();
    await this._ticketService
      .updateCategory(this.currentCategory.id, data)
      .then(() => {
        this._utilService.hideLoading();
        this._modalService.dismissAll();
        this._utilService.showSWALSuccess({ text: "SUCCESS_UPDATE_CATEGORY" });
        this.loadCategories();
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_UPDATE_CATEGORY" });
      });
  }

  async deleteCategory(currentCategory) {
    if (!this._authenticationService.hasCapability("ticket_category_delete")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += currentCategory.name;

    await this._utilService
      .showSWALDeleteConfirmation({ text: deleteText })
      .then(async (result) => {
        if (result.value) {
          await this._ticketService.deleteCategory(currentCategory.id);
          await this._utilService.showPopupItemDeleted().then(async () => {
            await this.loadCategories();
          });
        } else if (result.isDismissed) {
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      })
      .catch(() => this._utilService.showSWALError({ text: "ERROR_CATEGORY_REMOVE" }));
  }

  public modalOpen(modalBasic, currentCategoryId: number, action: string) {
    this._modalService.open(modalBasic, {
      size: "sm",
      centered: true,
    });

    if (action === "add") {
      this.new_category = "";
      this.new_description = "";
      this.addRoles = [];
    }
    if (action === "edit") {
      this.currentCategory = JSON.parse(JSON.stringify(currentCategoryId));
      if (this.currentCategory.roles && this.currentCategory.roles.length > 0) {
        this.addRoles = this.currentCategory.roles.map((role) => role.id);
      }
    }
    this.showModalErrors = false;
  }
}
